import { Pressable } from '@ayble-health/dashboard-components';
import React from 'react';

export const IconButton = ({ children, onClick }) => {
  return (
    <Pressable
      onClick={onClick}
      display="flex"
      borderRadius="100%"
      ml="4px"
      p="4px"
      bg="transparent"
      transition="background-color 350ms linear"
      _hover={{ bg: 'primary.50' }}
    >
      {children}
    </Pressable>
  );
};
